module.exports = __webpack_public_path__ + "static/media/ag-products6.f65e5441.jpg";